<div class="d-flex flex-column" [style.gap.rem]="2">
  <app-ep-self-enrolment-about [form]="form.controls.about" [formSubmitted]="formSubmitted" />
  <hr class="m-0" />
  <app-head-office-address-form-grid [form]="form.controls.headOfficeAddress" [formSubmitted]="formSubmitted" />
  <hr class="m-0" />
  <app-mailing-address-form-grid [form]="form.controls.mailingAddress" [formSubmitted]="formSubmitted" />
  <hr class="m-0" />
  <app-ep-self-enrolment-employer-logo [fileControl]="form.controls.logo" [formSubmitted]="formSubmitted" />
  <div class="d-flex justify-content-end">
    <app-primary-button i18n [size]="BaseButtonSizeEnum.md" (buttonClicked)="continue()">Continue</app-primary-button>
  </div>
</div>
